import { TopicFilterNames } from 'components/TopicFilters/shared';
import getPlaylistKPIURL, {
  IPlaylistKPIURLArgs,
} from './../../url-constructors/getPlaylistKPIURL';
import { EntityTypes } from './../../context/entityContext';
import getByUrl from './helper/getByUrl';
import createExportUrl from './helper/createExportUrl';

interface IPlaylistKPIInterceptorData {
  entityIds: string[];
  entityType: EntityTypes;
  countryIds?: string[] | undefined;
  customerFilter?: TopicFilterNames[];
  region?: string;
  customRegion?: string | string[];
  compareMode?: string;
}

const playlistKPIInterceptor = async (
  input: RequestInfo /* eslint-disable-line */,
  init: RequestInit | undefined /* eslint-disable-line */,
  interceptionData: IPlaylistKPIInterceptorData
): Promise<Response> => {
  const {
    entityIds,
    entityType,
    countryIds,
    customerFilter,
    region,
    customRegion,
    compareMode,
  } = interceptionData;

  const kpiOptions: IPlaylistKPIURLArgs = {
    countryIds,
    customerFilter,
    entityIds,
    entityType,
    region,
    customRegion,
    compareMode,
  };

  const kpiUrl: string = getPlaylistKPIURL(kpiOptions);

  try {
    const kpiData = await getByUrl<any>(kpiUrl);
    const exportUrl = createExportUrl(kpiUrl);

    return new Response(
      JSON.stringify({
        kpiData,
        exportUrl,
      })
    );
  } catch (error) {
    const errorInfo = await error.response.json();
    return new Response(
      JSON.stringify({
        reason: {
          error: errorInfo.message,
          errorInfo,
        },
      })
    );
  }
};

export default playlistKPIInterceptor;
